import { useState, useCallback } from 'react';
import apiService from '../services/api';

export const useLocations = () => {
  const [locations, setLocations] = useState({
    states: [],
    counties: [],
    cities: []
  });

  const fetchStates = useCallback(async () => {
    try {
      const data = await apiService.getStates();
      setLocations(prev => ({ ...prev, states: data }));
    } catch (error) {
      console.error('Error fetching states:', error);
    }
  }, []);

  const fetchCounties = useCallback(async (stateName) => {
    try {
      const data = await apiService.getCounties(stateName);
      setLocations(prev => ({ ...prev, counties: data, cities: [] }));
    } catch (error) {
      console.error('Error fetching counties:', error);
    }
  }, []);

  const fetchCities = useCallback(async (stateName, countyName) => {
    try {
      const data = await apiService.getCities(stateName, countyName);
      setLocations(prev => ({ ...prev, cities: data }));
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  }, []);

  return {
    locations,
    fetchStates,
    fetchCounties,
    fetchCities
  };
}; 